import React, { useMemo } from 'react'
import { Form } from 'antd-mobile'
import omit from 'lodash/omit'
import { FIELD_FILTER_LIST } from '@/libs/components/SchemaRendererForm/common/enum'
import {
  isHidden,
  shouldUpdate,
  SchemaContext,
} from '@/libs/components/SchemaRendererForm/common/util'
import SchemaRenderer, { SchemaRendererProps } from './schemaRenderer'
import {
  SchemaRendererFormProps,
  SchemaNode,
  RenderComponentProps,
} from './index.d'

/**
 * @description 用来隐藏组件
 * @param {RenderComponentProps} config
 * @param {RenderComponentProps} children
 */
const HiddenOnComponent = ({ config, children }: RenderComponentProps) => {
  return (
    <Form.Item
      noStyle
      shouldUpdate={(prevValues, nextValues) =>
        shouldUpdate(prevValues, nextValues, config)
      }
    >
      {({ getFieldsValue, getFieldValue }) => {
        const formValues = getFieldsValue()
        return isHidden(config, formValues) ? children() : null
      }}
    </Form.Item>
  )
}

/**
 * @description 用来渲染表单
 * @param {SchemaRendererFormProps} props
 */
const SchemaRendererForm = (props: SchemaRendererFormProps) => {
  /**
   * useMemo 缓存变量，如果依赖的变量没有发生变化，就不会重新计算
   */
  const rendererChildren = useMemo(() => {
    return props.schema.map((schemaNode: SchemaNode, index: number) => {
      const component = () => (
        <Form.Item {...omit(schemaNode, FIELD_FILTER_LIST)} key={index}>
          <SchemaRenderer
            schemaNode={schemaNode}
            customComponents={props.customComponents}
          />
        </Form.Item>
      )

      return schemaNode.hiddenOn ? (
        <HiddenOnComponent config={schemaNode.hiddenOn} key={index}>
          {component}
        </HiddenOnComponent>
      ) : (
        component()
      )
    })
  }, [props.schema, props.refreshMemo])

  return (
    <SchemaContext.Provider value={props?.contextDataCollection || {}}>
      {rendererChildren}
    </SchemaContext.Provider>
  )
}

SchemaRendererForm.SchemaRenderer = (props: SchemaRendererProps) => (
  <SchemaRenderer {...props} />
)

export default SchemaRendererForm
